module.exports = __webpack_public_path__ + "static/media/vogue.c776deea.svg";